import { db } from '../../../constants/firebaseModular';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { UpdateNavObjPayload } from '@usacsmideo/types';
import { deepEqual } from '../../../utilities/deepEqual';
import * as Sentry from '@sentry/browser';
// import { diff } from 'just-diff';

export const updateNavigationObject = async (payload: UpdateNavObjPayload) => {
  const docRef = doc(db, 'users', payload.uid);
  async function sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // SETTING SLEEP TO 1000ms TO PREVENT LOOP WHILE FIRESTORE UPDATES AND FRONT-END UPDATES THROUGH LISTENER
  await sleep(1000).then(async () => {
    const docSnap = await getDoc(docRef);
    if (docSnap && docSnap.exists()) {
      const data = docSnap.data();
      // IF THE NAV OBJECT IS THE SAME, DO NOTHING TO PREVENT INFINITE LOOPS
      if (deepEqual(data.navObj, payload.navObj)) {
        return;
      } else {
        await setDoc(docRef, { navObj: payload.navObj }, { merge: true });
      }
    } else {
      Sentry.captureMessage('No such document!');
      console.error('No such document!');
    }
  });
};
